module.exports = __webpack_public_path__ + "img/RD60.png";